import { render, staticRenderFns } from "./BkField.vue?vue&type=template&id=7aa0a830&scoped=true"
import script from "./BkField.vue?vue&type=script&lang=js"
export * from "./BkField.vue?vue&type=script&lang=js"
import style0 from "./BkField.vue?vue&type=style&index=0&id=7aa0a830&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa0a830",
  null
  
)

export default component.exports